export default {"src":"/_next/static/media/cross.f949321c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};